import React from 'react';

import { RightSidebar } from "../../../_partials/Layout";
import { UserInterface } from "../../../../store/roblox/usersSlice";
import RowInfo from "../../../../componets/RowInfo";
import { formatterToUnits } from "../../../../helpers/NumberHelper";
import { formattedDate } from "../../../../helpers/DateHelpers";
import {boolToText} from "../../../../helpers/TextHelpers";

const _SidebarShow = ({ user }: { user: UserInterface | undefined }) => {
  const renderDetails = () => {
    if(!user) {
      return null;
    }

    const banned  = () => user.banned_until ? renderDate(user.banned_until) : '';
    const muted   = () => user.muted_until ? renderDate(user.muted_until) : '';

    const renderDate = (date: string) => {
      const prepared = formattedDate(date);

      return <small>{prepared.date} <small>{prepared.time}</small></small>
    }

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Base Information</h6>

          <RowInfo left='#ID' right={user.id} />
          <RowInfo left='Coins' right={user.coins} />
          <RowInfo left='Email' right={user.email} />
          <RowInfo left='Last Ban' right={banned()} />
          <RowInfo left='Last Mute' right={muted()} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Launch Information</h6>

          <RowInfo left='Launch at' right={renderDate(user.launch_at)} />
          <RowInfo left='Previous launch at' right={renderDate(user.last_launch_at)} />
          <RowInfo left='Launch count' right={formatterToUnits(user?.launch_count || 0, 1)} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Active ADs</h6>

          <RowInfo left='Banner' right={boolToText(user.banner)} />
          <RowInfo left='Native Ads' right={boolToText(user.native)} />
          <RowInfo left='App Open' right={boolToText(user.app_open)} />
          <RowInfo left='Interstitial' right={boolToText(user.interstitial)} />
          <RowInfo left='Interstitial Long' right={boolToText(user.interstitial_long)} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
